import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalService } from 'src/app/shared/services/global.service';

@Component({
    selector: 'app-notfound',
    templateUrl: './notfound.component.html',
    styleUrls: ['./notfound.component.scss'],
    standalone: false
})
export class NotfoundComponent implements OnInit {
  constructor(private _router: Router, private globalService: GlobalService) {}

  ngOnInit(): void {}

  goHome() {
    this.globalService.clearCurCache = false;
    this._router.navigate(['/home']);
  }
}
